import { createFileRoute } from '@tanstack/react-router'
import { BlockedOrderExceptionPayersPage } from '../../-components/BlockedOrderExceptionPayersPage'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/blocked-orders/exception-payers/',
)({
  component: BlockedOrderExceptionPayersPage,
})
